import { Component, Injector, OnDestroy, OnInit } from '@angular/core';
import { DynamicBaseClass } from '../dynamic-base-class/dynamic-base-class.component';

@Component({
  standalone: false,
  selector: 'app-dynamic-image',
  templateUrl: './image.component.html',
  styleUrls: ['./image.component.scss']
})
export class ImageComponent extends DynamicBaseClass implements OnInit, OnDestroy {

  imageName: string;
  imageUrl: string;

  constructor(
    injector: Injector) {
    super(injector);
  }

  ngOnInit(): void {
    if (this.config) {
      this.imageName = this.config.imageName;
      this.imageUrl = './assets/' + this.imageName + '.png';
      super.GlobalConfig();
    }
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

}

